import { ReactNode } from "react";

export default function Container({
  children,
  className = "",
  inlineOnly,
}: {
  children: ReactNode;
  className?: string;
  inlineOnly?: boolean;
}) {
  return (
    <div
      className={`container ${className} ${inlineOnly ? "padding-inline" : ""}`}
    >
      {children}
    </div>
  );
}
